import { axios } from '@Api/axiosClient';
import type { Location } from '@Shared';

const baseUrl: string = 'api/Company';

export const getLocationInfoApi = async (): Promise<Location | null> => {
    try {
        const response = await axios.get(`${baseUrl}/GetLocationInfo`);
        return response.data ?? null;
    } catch (error) {
        return null;
    }
};
